import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// our components
import ProcessorRuleUpdate from 'components/ProcessorRule/Update';

const ScreenProcessorRuleUpdate = ({ classes, match, routePaths, target }) => (
  <div className={classes.container}>
    <GridContainer justify="center">
      <GridItem xs={12} sm={9} md={8} lg={7}>
        <ProcessorRuleUpdate
          id={match.params.id}
          routePaths={routePaths}
          target={target}
        />
      </GridItem>
    </GridContainer>
  </div>
);

ScreenProcessorRuleUpdate.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  routePaths: PropTypes.shape({}),
  target: PropTypes.string,
};

ScreenProcessorRuleUpdate.defaultProps = {
  routePaths: undefined,
  target: undefined,
};

export default withStyles(validationFormsStyle)(ScreenProcessorRuleUpdate);
